import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import 'primeicons/primeicons.css';
import './DoctorApproverMenu.css';
import { MenuItem } from 'primereact/menuitem';

const DoctorApproverMenu = () => {
  const items: MenuItem[] = [ { label: 'Doctors', icon: 'pi pi-user',url: '/medi/dadoctors' }, { label: 'Activities', icon: 'pi pi-bars', url: '/medi/daactivity' } ];
  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="menu-container" style={{margin:'0px 10px'}}>
          <PanelMenu model={items} style={{backgroundColor:'#fff'}} />
        </div>
      </div>
    </aside>
  );
};

export default DoctorApproverMenu;
